module.exports = __webpack_public_path__ + "static/media/hero-sell.6e180504.jpg";